
export function mapFieldsToSchema(fields) {
  return Object.entries(fields).map(([key, value]) => {
    let type = typeof value;

    if (Array.isArray(value)) {
      type = "array";
    }

    return {
      name: key,
      label: key, 
      type,
      value: Array.isArray(value) ? value : value ?? "",
    };
  });
}
